export const SecureTypeIDEnum = Object.freeze({
    OTPSMS : 1,
    OTPEmail: 2,
    OTPApp: 3,
    VoiceOTP: 19,
    ZaloOTP: 33,
    SMSMOMT: 999
  });